import React from "react"
import ToolTip from "react-portal-tooltip"
import { IPunchDocument } from "../../models"
import { grey500 } from "material-ui/styles/colors"
import AuditTable from "../audit/AuditTable"
interface IProps {
    punch: IPunchDocument
}
interface IState {
    open: boolean
}

export default class PunchAuditToolTipColumn extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            open: false
        }
    }

    render() {
        return (
            <div>
                <ToolTip
                    active={this.state.open}
                    position="right"
                    arrow="center"
                    parent={"#" + "punch-audit-" + this.props.punch.Id}
                    tooltipTimeout={50}
                >
                    <div style={{ width: 800, padding: 10, fontSize: 16, color: grey500 }}>
                        <AuditTable
                            audits={this.props.punch.PunchAudits}
                            hierarchyId={this.props.punch.HierarchyItemId}
                            jobId={this.props.punch.JobId}
                        />
                    </div>
                </ToolTip>
                <i
                    id={"punch-audit-" + this.props.punch.Id}
                    className="fa fa-info-circle"
                    style={{ color: grey500, cursor: "pointer", fontSize: 16 }}
                    onClick={() => this.setState({ open: !this.state.open })}
                    onMouseOut={() => this.setState({ open: false })}
                />
            </div>
        )
    }
}